export const STEP_CARD_WIDTH = 220;
export const STEP_CARD_PADDING = 10;
export const STEP_SLOT_HEIGHT = {
  edit: 180,
  stats: 260,
  history: 310,
} as const;
